<template>
  <b-modal
    centered
    :hide-footer="true"
    :hide-header="true"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    content-class="c-content"
    header-class="popup_header_noborder"
    body-class="c-body-no-padding"
    :visible="visible"
    @show="onShow"
    @hide="hide"
  >
    <div class="header">
      <div class="title">
        <span style="margin: auto">{{$t('home.monthly_site')}}</span>
        <h1><b-img class="mo_close_btn" style="margin-right: 0.5em;" @click="hide" :src="require('../../../assets/image/ic_close2.png')"/></h1>
<!--        <h1 style="margin: 0; color: gray" @click="hide"><b-icon icon="x"></b-icon></h1>-->
      </div>
      <b-tabs v-model="activeTab" fill style="width: 100%;">
        <b-tab :title="$t('map.new_open_site')" active title-link-class="tab_text tab"></b-tab>
        <b-tab :title="$t('map.general_site')"  title-link-class="tab_text tab"></b-tab>
      </b-tabs>
      <div style="height: 58px; margin-top: 10px;" class="center">
        <div class="pagination">
          <div @click="onYear(-1)" class="page_btn">&lt;&lt;&nbsp; </div>
          <div @click="onMonth(-1)" class="page_btn">&lt;&nbsp; </div>
          <div class="date">{{this.date.format('YYYY년 M월')}}</div>
          <div @click="onMonth(1)" class="page_btn">&gt;&nbsp;</div>
          <div @click="onYear(1)" class="page_btn">&gt;&gt;&nbsp;</div>
        </div>
      </div>
      <div class="desc">
        {{$t('home.monthly_site_desc')}}
      </div>
    </div>
    <div style="height: 100%; overflow: auto;" class="container scroll"  @scroll="onScroll" ref="wrap">
      <template v-for="item in dataList">
        <div v-if="item.type == 'date'" class="date_cell date_text">
          {{moment(item.data).format('M월 D일 (ddd)')}}
        </div>
        <div v-else @click="go2SiteDetail(item.data.f_idx)" class="site_cell">
          <div>
            <b-img :src="require('../../../assets/image/ic_address_detail@2x.png')" style="height: 1.2em; vertical-align: text-bottom;"/>
            <span class="site_name">{{item.data.f_name}}</span>
            <div v-if="item.data.f_supply_meal === 'Y'" class="badge_tail badge_finish" />
            <div v-if="item.data.f_supply_meal === 'Y'" class="badge">
              <span class="badge_text">{{$t('site_detail.meal')}}</span>
            </div>
          </div>
          <div class="site_address">{{item.data.f_address1}} {{item.data.f_address2}}</div>
        </div>
      </template>
    </div>
    <SiteDetail v-if="siteDetailData != null" :visible.sync="showSiteDetailPopup" :site="siteDetailData" />

  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
import SiteDetail from "../../contents/main/interest/SiteDetail";
const TAB = {
  NEW: 'O',
  GENERAL: 'G',
  ALL: '',
};

export default {
  name: "MonthlySalePopup",
  components:{
    SiteDetail,
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      moment:moment,
      date: moment(),
      list: [],
      loadingEnd: false,
      pageNum: 1,
      activeTab: 0,
      dataList:[],
      bodyMarginTop:'1em',
      showSiteDetailPopup:false,
      siteDetailData:null,
      isLoad: false,
    }
  },
  methods:{
    onScroll(){
        let wrap = this.$refs.wrap;
        console.log("-scroll value =", wrap.scrollHeight - Math.ceil(wrap.scrollTop), wrap.clientHeight);
        if((wrap.scrollHeight - Math.ceil(wrap.scrollTop) < wrap.clientHeight + 5) && wrap.scrollHeight - Math.ceil(wrap.scrollTop) > wrap.clientHeight - 5){ //end of scroll
          if (!this.loadingEnd && !this.isLoad){
            this.getList();
          }
        }
    },
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },
    initList(tab){
        this.list = [];
        this.loadingEnd = false;
        this.pageNum = 1;
        this.activeTab = tab;
        this.getList();
    },

    getList(){
      if (this.loadingEnd || this.isLoad) {
        return;
      }

      this.isLoad = true;

      Utils.requestGet(
        this.$c.API.Site.getInterestSiteList,
        {
          type: this.activeTabName,
          page_num: this.pageNum,
          date: this.date.format('YYYY-MM')
        },
      ).then(result => {
        this.isLoad = false;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
           this.list = this.list.concat(result.data.list);
          this.loadingEnd = result.data.list.length < result.data.limit;
           this.pageNum = ++this.pageNum;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    hide(){
      if(window.history.state == "forward")
        window.history.back();
    },
    onYear(year){
      this.date = this.date.clone().add(year, 'year')
      this.initList(this.activeTab);
    },

    onMonth(month) {
      this.date = this.date.clone().add(month, 'month')
      this.initList(this.activeTab);
    },
    go2SiteDetail(siteIdx){
      this.eventBus.$emit("checkTicketAvailable", ()=>{
        Utils.requestGet(
          this.$c.API.Site.getSiteDetail,
          {
            site_idx: siteIdx,
          },
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.siteDetailData = result.data;
            this.showSiteDetailPopup = true;
          } else {
            Utils.toast(this, result.msg);
          }
        });
      });
    },
  },
  computed:{
    renderData(){
      let result = [];

      if (this.list.length < 1) {
        return result;
      }

      let date = '';
      this.list.forEach(item => {
        let tmpDate = this.activeTabName == TAB.NEW ? item.f_open_date.substr(0, 10) : item.f_reg_time.substr(0, 10);
        if (date != tmpDate) {
          result.push({
            type: 'date',
            data: tmpDate
          });
          date = tmpDate;
        }
        result.push({
          type: 'site',
          data: item
        });
      });
      return result;
    },

    activeTabName(){
      switch (this.activeTab){
        case 0: return TAB.NEW;
        case 1: return TAB.GENERAL;
      }
    }
  },
  watch:{
    list(){
      this.dataList = this.renderData;
    },
    activeTab(){
      this.initList(this.activeTab);
    }
  },
  mounted() {
    moment.locale('ko');
    this.initList(this.activeTab);
  },
  inject: ['eventBus'],
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";

.header{
  width: 100%;
  //z-index: 0;
  background: white;
}



.center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination{
  @extend .center;
  height: 50px;
}

.page_btn{
  @extend .center;
  width: 50px;
  height: 25px;
  color: #919191;
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
  cursor: pointer;
}

.date{
  color: $black;
  font-size: $fs_20;
  padding:0 5px;
  font-family: $korean_gd_16_r
}
.desc{
  color: #d21111;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
  margin-right :15px;
  text-align: right;
}
.border{
  border-style:solid;
  border-radius: 5px;
  border-width: 1px;
  border-color: #dfdcdc;
  margin-bottom: 6px;
}

.date_cell{
  @extend .border;
  @extend .center;
  height: 42px;
  background-color: #e6f0fd;
  box-shadow: 0 6px 6px rgba(0,0,0,0.08);
};

.date_text{
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  padding-top: 2px;
}



.site_cell{
  @extend .border;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 80px;
  padding:0 15px;
  background-color: white;
  box-shadow: 0 6px 6px rgba(0,0,0,0.08);
  position:relative;
  overflow: hidden;
}

.site_name{
  color: #0660e2;
  font-size: $fs_19;
  font-family: $korean_gd_15_r
}

.site_address{
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_13_r;
  margin-top: 2px;
}

.title{
  display: flex;
  font-family: $korean_gd_15_r;
  font-size: $fs_18;
  margin-left: 30px;
}

.badge {
  position: absolute !important;
  top: 8px;
  right: 0;
  padding-right: 3px;

  /** Rotation */
  -webkit-transform: rotate(40deg); 
  -moz-transform: rotate(40deg);    
  transform:rotate(40deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.badge_text {
  color: $white;
  font-size: 20px;
  font-family: $korean_gd_13_r;
  margin-top: 4px;
  margin-right: 2px;
}

.badge_finish {
  border-top-color: $yellow_bg;
}

.badge_tail {
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  background-color: transparent;
  border-style: solid;
  border-left-width: 70px;
  border-right-width: 0;
  border-top-width: 65px;
  border-bottom-width: 0;
  border-left-color: transparent;
  border-right-color: transparent;
}

</style>

<style lang="scss" >

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/MonthlySalePopup.vue